import React from 'react';
import ProofingPanel from '../../Components/ProofingPanel'
import block from 'bem-cn-lite';

class Controls extends React.Component {
    clickHandler = (event) => {
        event.preventDefault()

        const {onProgressBarClick, onClick, onPlayPauseClick, isActiveComments} = this.props;

        if (isActiveComments) {
            return;
        }

        if (event.target.id === 'play-pause-btn') {
            onPlayPauseClick();
            return;
        }

        if (event.target !== this.progressBar && !this.progressBar.contains(event.target)) {
            onClick();
            return;
        }

        const clickPosition = this.getCursorPosition(event);
        const progressTimeSeconds = Math.floor((clickPosition.x * 290) / 480);

        onProgressBarClick(clickPosition.x, progressTimeSeconds);
    }

    getCursorPosition(event) {
        const {x, y} = this.getNodePosition(this.progressBar);

        return {
            x: event.nativeEvent.clientX - x,
            y: event.nativeEvent.clientY - y,
        };
    }

    getNodePosition(node) {
        const rect = node.getBoundingClientRect();

        return {
            x: rect.left,
            y: rect.top
        };
    }

    getFormattedTime = (progressTimeSeconds) => {
        const minutes = Math.floor(progressTimeSeconds / 60);
        let seconds = progressTimeSeconds - minutes * 60;
        seconds = seconds < 10 ? '0' + String(seconds) : String(seconds);

        return String(minutes) + ':' + String(seconds);
    }

    render() {
        const b = block('Controls');

        const {
            isActiveComments,
            isDisabled,
            progressLinePosition,
            progressTimeSeconds,
            isVisibleTooltip,
            isPlaying
        } = this.props;

        const formattedTime = this.getFormattedTime(progressTimeSeconds);

        return (
            <div
                onClick={this.clickHandler}
                className={b()}>
                <ProofingPanel commentsIsActive={isActiveComments}>
                    <div
                        ref={(ref) => this.progressBar = ref}
                        className={b('progress-bar-wrap')}>

                        {isVisibleTooltip && <div className="blink"/>}

                        <div className={b('progress-bar')}>
                            <div className={b('progress-line')}
                                style={{width: progressLinePosition + 'px'}}>
                                <span
                                    className={b('progress-line-checkpoint', {isDisabled: isDisabled})}
                                    style={{left: progressLinePosition + 'px'}}>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className={b('bottom')}>
                        <div className={b('video-controls')}>
                            <div className={b('video-control-item')}>
                                <button className={b('play-pause-btn', {isPlaying: isPlaying})} id="play-pause-btn" />
                            </div>

                            <div className={b('video-control-item')}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16">
                                    <path fill="#FFF" fillRule="evenodd" d="M17.5 8.5L20 6l-1-1-2.5 2.5L14 5l-1 1 2.5 2.5L13 11l1 1 2.5-2.5L19 12l1-1-2.5-2.5zM0 6h3l6-6v16c-2-1.83333-6-6-6-6H0V6z" opacity=".9"/>
                                </svg>
                            </div>

                            <div className={b('video-control-item')}>
                                <div className={b('progress-time')}>
                                    <span className={b('progress-time-current')}>
                                        {formattedTime}
                                    </span> /
                                    <span>4:50</span>
                                </div>
                            </div>
                        </div>

                        <div className={b('tools')}>
                            <img src="https://cdn.wrike.com/image/__cdnu/illustration_abstract_image-proofing-panel.svg" alt=""/>
                        </div>
                
                    </div>


                </ProofingPanel>
            </div>
        )
    }
}

export default Controls;